import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api, formatPrice } from "@/lib/api";
import { Package, ShoppingBag, Clock, DollarSign } from "lucide-react";

export default function AdminDashboard() {
    const { data: stats } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data });
    const { data: orders = [] } = useQuery({ queryKey: ["admin-orders-recent"], queryFn: async () => (await api.get("/orders")).data });
    const cards = [
        { label: "Productos", value: stats?.products || 0, icon: <Package className="w-5 h-5" />, color: "bg-denim/10 text-denim" },
        { label: "Pedidos totales", value: stats?.orders || 0, icon: <ShoppingBag className="w-5 h-5" />, color: "bg-ink/10 text-ink" },
        { label: "Pendientes", value: stats?.pending || 0, icon: <Clock className="w-5 h-5" />, color: "bg-terracotta/10 text-terracotta" },
        { label: "Ingresos", value: formatPrice(stats?.revenue || 0), icon: <DollarSign className="w-5 h-5" />, color: "bg-emerald-100 text-emerald-700" },
    ];
    return (
        <div>
            <h1 className="font-display text-3xl text-ink mb-8">Dashboard</h1>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
                {cards.map((c) => (
                    <div key={c.label} className="bg-white rounded-lg p-5 border border-sandLight">
                        <div className={`w-10 h-10 rounded-md flex items-center justify-center ${c.color} mb-4`}>{c.icon}</div>
                        <p className="text-xs uppercase tracking-wider text-ink/50">{c.label}</p>
                        <p className="text-2xl font-medium mt-1 text-ink">{c.value}</p>
                    </div>
                ))}
            </div>
            <div className="bg-white rounded-lg p-6 border border-sandLight">
                <h2 className="font-display text-xl mb-4">Pedidos recientes</h2>
                <div className="divide-y divide-sandLight">
                    {orders.slice(0, 10).map((o) => (
                        <Link to={`/admin/pedidos?open=${o.id}`} key={o.id} data-testid={`recent-order-${o.id}`} className="py-3 flex items-center justify-between text-sm hover:bg-bone/60 px-2 -mx-2 rounded transition-colors cursor-pointer">
                            <div>
                                <p>#{o.id.slice(0, 8)} · {o.customer?.name}</p>
                                <p className="text-xs text-ink/50">{new Date(o.created_at).toLocaleString("es-CO")}</p>
                            </div>
                            <div className="text-right">
                                <p>{formatPrice(o.total)}</p>
                                <p className="text-xs uppercase text-ink/60">{o.status}</p>
                            </div>
                        </Link>
                    ))}
                    {orders.length === 0 && <p className="text-sm text-ink/50 py-6 text-center">Aún sin pedidos.</p>}
                </div>
            </div>
        </div>
    );
}
